import { ThemeProps } from '@mutiny-pkg/champaign-schemas/src/schemas/flexiblePages/themeSchema';
import { ThemeProperties } from '@mutiny-pkg/champaign-schemas/src/schemas/themeProperties/types';
import { useEffect, useRef } from 'react';

export const loadFontFace = async (fontFamily: string, fontWeight: string, src: string, style?: string) => {
  if (!fontFamily || !fontWeight || !src) {
    return;
  }

  const fontFace = new FontFace(fontFamily, `url(${src})`, { weight: fontWeight, style: style || 'normal' });
  document.fonts.add(fontFace);
  try {
    await fontFace.load();
  } catch (error) {
    console.warn('Error loading font face', error);
  }
};

export function useFonts(fontFaces: ThemeProperties['fontFaces'] | ThemeProps['fonts'], dynamicFonts: boolean) {
  const loadedFontsRef = useRef<ThemeProperties['fontFaces']>([]);

  useEffect(() => {
    if (!dynamicFonts) {
      return;
    }

    fontFaces?.forEach((font) => {
      // Old schema font face
      if ('src' in font) {
        if (loadedFontsRef.current.includes(font)) {
          return;
        }
        loadFontFace(font.fontFamily, font.fontWeight, font.src, font.fontStyle);
        loadedFontsRef.current.push(font);
      }

      // New schema font face
      if ('variants' in font) {
        font.variants?.forEach((variant) => {
          const fontFace = {
            fontFamily: font.family,
            fontWeight: variant.weight,
            src: variant.url,
            fontStyle: variant.style,
          };
          if (loadedFontsRef.current.includes(fontFace)) {
            return;
          }
          loadFontFace(fontFace.fontFamily, fontFace.fontWeight, fontFace.src, fontFace.fontStyle);
          loadedFontsRef.current.push(fontFace);
        });
      }
    });
  }, [fontFaces, dynamicFonts]);
}
